/**
 * Csv Schema of StatusSms
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {StatusSms} from '@/model/resource/StatusSms'

/* TODO: review generated schema */
export class CsvStatusSmsSchema extends Schema {
  readonly name = 'CsvStatusSms'

  readonly fieldSet: FieldSet<StatusSms> = {
    idStatusPk: schema => schema.model.idStatusPk,
    nome: schema => schema.model.nome,
    ativo: schema => Helper.bool(schema.model.ativo),
  }
}
